export default "__VITE_ASSET__2$cOE11A__"